<app-navbar />

<div class="dashboard-admin container-fluid">
    <div class="filters mb-3">
        <div style="display:flex; gap:8px; width: 100%;">
            <div style="flex: 1 1 200px;">
                <select class="form-select form-select-sm" [(ngModel)]="periodoSelecionado"
                    (ngModelChange)="onPeriodoChange()">
                    <option value="hoje">Hoje</option>
                    <option value="semana">Última Semana</option>
                    <option value="mes">Último Mês</option>
                    <option value="custom">Personalizado</option>
                </select>

                <div *ngIf="periodoSelecionado === 'custom'" class="custom-dates mt-2">
                    <input type="date" class="form-control form-control-sm" [(ngModel)]="dataInicialInput"
                        (ngModelChange)="onDataInicialChange($event)">
                    <input type="date" class="form-control form-control-sm" [(ngModel)]="dataFinalInput"
                        (ngModelChange)="onDataFinalChange($event)">
                </div>
            </div>

            <div style="flex: 0 0 240px;">
                <select class="form-select form-select-sm" [(ngModel)]="municipioSelecionado"
                    (ngModelChange)="onPeriodoChange()">
                    <option value="">Todos os municípios</option>
                    <option *ngFor="let m of municipiosOptions" [value]="m">{{ m }}</option>
                </select>
            </div>
        </div>
    </div>

    <div class="row stats-row">

        <div class="col-12 col-md-6">
            <div class="card p-3 progresso-card modern" style="height:360px;">
                <div class="d-flex align-items-center gap-3">
                    <div class="chart-wrap">
                        <apx-chart [series]="progressoSeries" [chart]="progressoChart"
                            [plotOptions]="progressoPlotOptions" [colors]="progressoColors"></apx-chart>
                    </div>

                    <div class="flex-fill">
                        <div class="d-flex justify-content-between align-items-center">
                            <h6 class="mb-0">Progresso para objetivo</h6>
                            <div *ngIf="progressoPercent >= 100" class="badge bg-success">Atingido</div>
                        </div>
                        <div class="mt-2">
                            <div class="muted">Total</div>
                            <div class="total-display"><strong>{{ totalGeral | number }}</strong></div>
                        </div>

                        <div class="mt-3">
                            <div class="d-flex gap-2 align-items-center">
                                <input type="number" class="form-control form-control-sm objetivo-input"
                                    [value]="objetivo" (input)="onObjetivoChange($any($event.target).value)"
                                    aria-label="Objetivo" placeholder="Digite o objetivo">
                            </div>

                            <div class="progress mt-3" style="height:10px;">
                                <div class="progress-bar" role="progressbar" [class.bg-success]="progressoPercent>=100"
                                    [class.bg-warning]="progressoPercent>=50 && progressoPercent<100"
                                    [class.bg-info]="progressoPercent<50"
                                    [style.width.%]="progressoPercent>100 ? 100 : progressoPercent"
                                    [attr.aria-valuenow]="progressoPercent" [attr.aria-valuemin]="0"
                                    [attr.aria-valuemax]="100"></div>
                            </div>

                            <div class="d-flex justify-content-between small mt-2 text-muted">
                                <div>Progresso: <strong>{{ progressoPercent }}%</strong></div>
                                <div>Faltam: <strong>{{ faltam | number }}</strong></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6">
            <div class="card p-3" style="height:360px;">
                <h6>Vistorias por município</h6>
                <div style="height:300px;">
                    <apx-chart [series]="vistoriasPieSeries" [chart]="vistoriasChart"
                        [plotOptions]="vistoriasPlotOptions" [labels]="vistoriasPieLabels"
                        [colors]="vistoriasPieColors" [legend]="vistoriasLegend"
                        [dataLabels]="vistoriasDataLabels"></apx-chart>
                </div>
            </div>
        </div>

        <div class="col-12 col-md-8 mt-3">
                <div class="card p-2" style="height: 360px;">
                    <h6>Total de vistorias por dia (filtro aplicado)</h6>
                    <div style="height:300px;">
                        <apx-chart [series]="combinedSeries" [chart]="combinedChart" [xaxis]="combinedXAxis"
                            [colors]="combinedColors" [plotOptions]="combinedPlotOptions"
                            [dataLabels]="combinedDataLabels" [stroke]="combinedStroke" [yaxis]="combinedYAxis" [tooltip]="combinedTooltip"></apx-chart>
                    </div>
                </div>
        </div>
    </div>

    <div *ngIf="loading" class="mt-3">Carregando...</div>
    <div *ngIf="errorMessage" class="text-danger mt-2">{{ errorMessage }}</div>

</div>